import { localCheckboxStyle } from "@components/commerce/product-listing/filters/toolbar/item/common/CommonToolbarFilterStyles";
import { Box } from "@ui/components/layout/box/Box";
import { Text } from "@ui/components/content/text/Text";
import { focusOutline } from "@ui/css/02.focus/focus.styles";
import { scrollbarStyles } from "@ui/css/01.scrollbar/scrollbar.styles";
import { SelectDropdownItem } from "@ui/components/overlay/select-dropdown/SelectDropdown";
import { FilterBase } from "@components/commerce/product-listing/filters/common/filter/FilterBase";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { Checkbox } from "@ui/components/forms/checkbox/Checkbox";

export interface CommonToolbarFilterProps {
    initialFilters: RefinementListItem[];
    filterName: string;
    items: RefinementListItem[];
    refine: (value: string) => void;
    isToolbar: boolean;
    isLoading: boolean;
}

export const CommonToolbarFilter = ({
    initialFilters,
    items,
    refine,
    filterName,
    isToolbar,
    isLoading,
}: CommonToolbarFilterProps) => {
    const dropdownItems = (
        <Box
            role="menu"
            sx={{
                ...scrollbarStyles,
                minWidth: ["auto", "210px"],
                height: "auto",
                maxHeight: "500px",
                overflowY: "auto",
                padding: 3,
            }}
        >
            {initialFilters?.map((item) => {
                const dynamicItem = items.find((it) => it.value === item.value);

                return (
                    <SelectDropdownItem
                        key={item.label}
                        sx={{
                            ...localCheckboxStyle,
                            _focusVisible: {
                                ...focusOutline,
                            },
                            _focus: {
                                background: "transparent",
                            },
                            _hover: { backgroundColor: "transparent", outline: "none" },
                        }}
                        onClick={() => refine(item.value)}
                        isDisabled={!dynamicItem}
                    >
                        <Checkbox
                            _focusVisible={{
                                ...focusOutline,
                            }}
                            _hover={{
                                outline: "none",
                            }}
                            id={item.label}
                            colorScheme={"black"}
                            key={item.label}
                            value={item.label}
                            onChange={() => refine(item.value)}
                            isChecked={dynamicItem?.isRefined}
                            isDisabled={!dynamicItem}
                            _disabled={{
                                cursor: "default !important",
                            }}
                        >
                            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                                <Text noOfLines={1} fontWeight={"bold"}>
                                    {item.label}
                                </Text>
                                <Text color={"gray.700"} fontWeight={"bold"}>
                                    ({dynamicItem?.count ?? 0})
                                </Text>
                            </Box>
                        </Checkbox>
                    </SelectDropdownItem>
                );
            })}
        </Box>
    );

    return (
        <FilterBase
            isLoading={isLoading}
            dropdownItems={dropdownItems}
            filterName={filterName}
            isToolbar={isToolbar}
        />
    );
};
